<template>
  <div class="formula-horizontal-header">
    <div
      v-for="(card, index) in cards"
      :key="`${card.label}-${index}`"
      class="formula-horizontal-header__row"
    >
      <div class="formula-horizontal-header__operator-wrap" :aria-hidden="!card.operator">
        <span v-if="card.operator" class="formula-horizontal-header__operator">{{
          card.operator
        }}</span>
      </div>
      <div
        class="formula-horizontal-header__card"
        :class="{ 'formula-horizontal-header__card--active': index === selectedIndex }"
        @click="$emit('select', index)"
      >
        <div class="formula-horizontal-header__content">
          <div class="formula-horizontal-header__left">
            <span class="formula-horizontal-header__label">{{ card.label }}</span>
            <span class="formula-horizontal-header__status">{{
              card.status ? card.status : ''
            }}</span>
          </div>
          <span class="formula-horizontal-header__value">{{ card.value || '--' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormulaHorizontalHeader',
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
    selectedIndex: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>
.formula-horizontal-header {
  display: flex;
  align-items: stretch;
  // gap: 24px;
  // margin: 20px 0 32px;
  padding-left: 34px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
}

.formula-horizontal-header__row {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.formula-horizontal-header__operator-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.formula-horizontal-header__operator {
  font-family: DiDiSans-Pro-Regular;
  font-size: 48px;
  line-height: 1;
  color: #bababf;
  margin: 0 16px;
}

.formula-horizontal-header__card {
  width: auto;
  min-height: 156px;
  padding: 0;
  border-radius: 24px;
  border: 4px solid transparent;
  background: rgba(242, 242, 245, 0.5);
  box-sizing: border-box;
  display: flex;
  align-items: stretch;
}

.formula-horizontal-header__card--active {
  border-color: #0d86ff;
}

.formula-horizontal-header__content {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  padding: 24px;
}

.formula-horizontal-header__left {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 24px;
  text-align: left;
}

.formula-horizontal-header__label {
  font-family: DiDi Sans Pro;
  font-size: 24px;
  line-height: 32px;
  color: #0c0c0d;
}

.formula-horizontal-header__status {
  font-family: DiDiSans-Pro-Bold;
  font-size: 22px;
  line-height: 32px;
  min-height: 32px;
  color: #ff1965;
}

.formula-horizontal-header__value {
  font-family: DiDiSans-Pro-Bold;
  font-size: 56px;
  line-height: 64px;
  color: #282b33;
  white-space: nowrap;
  text-align: left;
}
</style>
